import { animate, style, transition, trigger } from '@angular/animations';

/**
 * Fade-in/fade-out (com leve deslize vertical) do painel de opções do
 * `ai-multi-select-input`. Curto o suficiente para parecer responsivo.
 *
 * O `:leave` exige que o painel permaneça no DOM até o fim do fade — por isso
 * é aplicado ao elemento renderizado por `@if (optionsVisible())`.
 */
export const multiSelectFade = trigger('multiSelectFade', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-4px)' }),
        animate(
            '150ms ease',
            style({ opacity: 1, transform: 'translateY(0)' }),
        ),
    ]),
    transition(':leave', [
        animate(
            '120ms ease',
            style({ opacity: 0, transform: 'translateY(-4px)' }),
        ),
    ]),
]);

/** Duração (ms) do fade-out. */
export const MULTI_SELECT_FADE_MS = 120;
